import gql from 'graphql-tag';

import cardDetails from '../../../../services/cards/graphql/fragments/cardDetails';

export const cardCreate = gql`
  mutation cardCreate($input: CardCreateInput!) {
    cardCreate(input: $input) {
      card {
        ...cardDetails
      }
    }
  }
  ${cardDetails}
`;

export const cardUpdate = gql`
  mutation cardUpdate($input: CardUpdateInput!) {
    cardUpdate(input: $input) {
      card {
        ...cardDetails
      }
    }
  }
  ${cardDetails}
`;

export const cardsDelete = gql`
  mutation cardsDelete($input: CardsDeleteInput!) {
    cardsDelete(input: $input) {
      success
    }
  }
`;
